import { render, staticRenderFns } from "./state-licenses.vue?vue&type=template&id=21da7d94&scoped=true"
import script from "./state-licenses.vue?vue&type=script&lang=js"
export * from "./state-licenses.vue?vue&type=script&lang=js"
import style0 from "./state-licenses.vue?vue&type=style&index=0&id=21da7d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da7d94",
  null
  
)

export default component.exports